import { APP_NAME } from '../../shared/brand';
import aboutSource from '../../content/about.md?raw';
import { PublicShell } from '../components/PublicShell';
import { AboutMarkdown } from '../lib/aboutMarkdown';
import { usePageMeta } from '../lib/meta';

const TITLE = `About · ${APP_NAME}`;
const DESCRIPTION =
  'Patrick Simpson on why Grams uses gram-accurate food logging, daily weigh-ins, and a moving average to show where your weight really is.';

/** Founder note from content/about.md. Same page inside the app and on the public site. */
export function AboutPage() {
  usePageMeta(TITLE, DESCRIPTION);
  return (
    <article className="page about" data-page="about">
      <header className="page__head">
        <div>
          <h1 className="page__title">About</h1>
          <p className="page__sub">A note from Patrick Simpson.</p>
        </div>
      </header>
      <div className="card card--pad about-prose">
        <AboutMarkdown source={aboutSource} />
      </div>
    </article>
  );
}

/** About, with the signed-out header and footer. */
export function PublicAboutPage() {
  return (
    <PublicShell>
      <AboutPage />
    </PublicShell>
  );
}
